import React, { useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Context } from "./Context.js";

import { styled, useTheme } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import InboxIcon from "@mui/icons-material/Inbox";

import { useNavigate } from "react-router-dom";

const drawerWidth = 240;
// ancoriamo a destra
const drawerAnchor = "right";

const DrawerHeaderBase = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

export default function InfoUserAdmin() {
  const { nome, idTipoUtente } = useContext(Context);

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const navigate = useNavigate();

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  function clickMenuSx(idSelezionato) {
    switch (idSelezionato) {
      case 0:
        return navigate("/listaAbbonamenti");
      case 1:
        if (idTipoUtente !== 5) return navigate("/listaUtenti");
        return;
      case 2:
        if (idTipoUtente !== 5) return navigate("/invioEmail");
        return;
      case 3:
        return navigate("/RegistroAccessi");
      default:
        return;
    }
  }

  const iconsArray = [
    { id: 0, avatarIcon: <ConfirmationNumberIcon />, message: "Abbonamenti" },
    { id: 1, avatarIcon: <PersonIcon />, message: "Utenti" },
    { id: 2, avatarIcon: <EmailIcon />, message: "Manda email" },
    { id: 3, avatarIcon: <InboxIcon />, message: "Registro Accessi" },
  ];

  // header del drawer: per anchor right il chevron "chiude" verso destra
  const DrawerHeader = (props) => (
    <DrawerHeaderBase
      {...props}
      style={{
        justifyContent: drawerAnchor === "right" ? "flex-start" : "flex-end",
        ...(props.style || {}),
      }}
    />
  );

  const CloseIcon =
    drawerAnchor === "right"
      ? theme.direction === "ltr"
        ? ChevronRightIcon
        : ChevronLeftIcon
      : theme.direction === "ltr"
      ? ChevronLeftIcon
      : ChevronRightIcon;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="relative">
        <Toolbar>
          {/* Titolo a sinistra */}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Fidal Brescia - ADMIN
          </Typography>

          {/* Nome utente a destra del titolo */}
          <Typography variant="h6" component="div" sx={{ mr: 1 }}>
            {nome}
          </Typography>

          {/* Icona hamburger A DESTRA, che apre un drawer destro */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="end"
            sx={{ ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,

          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            bgcolor: "#5E2367", // oppure: 'primary.dark'
            color: "#fff", // testo leggibile
            backgroundImage: "none",
          },
        }}
        variant="persistent"
        anchor={drawerAnchor}
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            <CloseIcon sx={{ color: "#fff" }} />
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {iconsArray.map((item) => (
            <ListItem key={item.id} disablePadding>
              <ListItemButton onClick={() => clickMenuSx(item.id)}>
                <ListItemIcon sx={{ color: "#fab720" }}>
                  {item.avatarIcon}
                </ListItemIcon>
                <ListItemText
                  sx={{
                    color: "#fff",
                    "& .MuiTypography-root": { fontSize: "1.1rem" },
                  }}
                  primary={item.message}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </Box>
  );
}
